import {Strand} from 'constants/MolbioConstants';
import {BLUE_DARKER, BLUE_POWDER_LIGHT, PURPLE, RED_DARK, RED_POWDER} from 'ui-library/Colors';

export interface VisualPolymerFragment {
  start: number;
  end: number;
  color: string;
  homologyRegionOtherColor: string | null;
}

export interface VisualPolymerFeature {
  start: number;
  end: number;
  color: string;
  name: string;
  strand: Strand;
}

export enum PolymerPreviewOverlayType {
  INSERT = 'INSERT',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
}

export interface PolymerPreviewOverlay {
  type: PolymerPreviewOverlayType;
  start: number;
  end: number;
  color?: string;
}

export interface VisualSequenceCutSite {
  enzymeId: number;
  position: number;
}
export interface VisualPolymer {
  circular: boolean;
  fragments: Array<VisualPolymerFragment>;
  length: number;
  startIndex: number;
  cutSites: Array<VisualSequenceCutSite>;
  annotations: Array<VisualPolymerFeature>;
  overlays: Array<PolymerPreviewOverlay>;
}

export const POLYMER_PREVIEW_OVERLAY_TYPE_TO_BG_COLOR = {
  [PolymerPreviewOverlayType.INSERT]: BLUE_POWDER_LIGHT,
  [PolymerPreviewOverlayType.DELETE]: RED_POWDER,
  [PolymerPreviewOverlayType.UPDATE]: null,
};

export const POLYMER_PREVIEW_OVERLAY_TYPE_TO_COLOR = {
  [PolymerPreviewOverlayType.INSERT]: BLUE_DARKER,
  [PolymerPreviewOverlayType.DELETE]: RED_DARK,
  [PolymerPreviewOverlayType.UPDATE]: PURPLE,
};
